function disableEmptyFields(form: HTMLFormElement) {
	const fields = form.querySelectorAll<
		HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
	>('input, textarea, select');

	const emptyFields = [...fields].filter(
		(field) => field.value === '' && field.disabled === false
	);

	emptyFields.forEach((field) => {
		field.disabled = true;
	});

	return () => {
		emptyFields.forEach((field) => {
			field.disabled = false;
		});
	};
}
export default function bindRemoveEmptyFieldsOnFormSubmit() {
	document.addEventListener('submit', (event) => {
		if (event.target instanceof HTMLFormElement) {
			const form = event.target;

			if (form.classList.contains('js-remove-empty-fields')) {
				event.preventDefault();

				const revert = disableEmptyFields(form);
				form.submit();
				revert();
			}
		}
	});
}
